export default "__VITE_ASSET__BGbkJXHb__"